import { JSXElement, mergeProps, Show } from 'solid-js';
import HostedAuthGenericBoxWithLogo from '~/pages/ExternalPages/commons/components/HostedAuthGenericBoxWithLogo.tsx';
import { usePortalCustomizationContext } from '~/portal-customization/PortalCustomizations.tsx';
import { getTranslationKeyFunction } from '~/utils/commonUtils.ts';
import { Localized } from '~/i18n';

const getEnvAppErrorTranslationKey = getTranslationKeyFunction(
  `server_errors.external.env_app_pages`
);

type GenericEnvAppErrorProps = {
  header?: string;
  subheader?: string;
};

export default function GenericEnvAppError(
  props: GenericEnvAppErrorProps
): JSXElement {
  const merged = mergeProps({}, props);
  const portalCustomizationContext = usePortalCustomizationContext();

  return (
    <HostedAuthGenericBoxWithLogo>
      <Show when={merged.header}>
        <div class={`text-xl`}>{merged.header}</div>
      </Show>
      <div class={`text-sm mt-8 font-normal text-center self-stretch`}>
        <Show when={merged.subheader}>{merged.subheader}</Show>
      </div>
      <div class={`text-sm mt-4 font-normal text-center self-stretch`}>
        <Show
          when={portalCustomizationContext.appConfig?.supportEmail}
          fallback={
            <Localized
              translationKey={getEnvAppErrorTranslationKey(
                'contact_support_without_email'
              )}
            />
          }
        >
          <Localized
            translationKey={getEnvAppErrorTranslationKey(
              'contact_support_with_email'
            )}
            vars={{
              supportEmail: () => (
                <a
                  class={`underline font-medium`}
                  href={`mailto:${portalCustomizationContext.appConfig?.supportEmail}`}
                >
                  {portalCustomizationContext.appConfig?.supportEmail ?? ''}
                </a>
              )
            }}
          />
        </Show>
      </div>
    </HostedAuthGenericBoxWithLogo>
  );
}
